<div data-component="scroll_to_top" data-module="cova_reactive" data-view="index">
  <div *ngIf="isCovaEnabled === true" class="cova_container">
    <div *ngIf="isChatBotEnabled === true" class="cova_container">
      <div class="cova_chat_text_bubble" [hidden]="!showChatBubble" tabindex="0" [innerHTML]="pageData?.copy$$label_how_can_i_help?.TEXT"></div>
      <div *ngIf="isIEorEdge !== true && isChatBotAnimationEnabled === true" class="cova_chat_bot_wrapper">
        <div class="cova_chat_bot_background" ></div>
        <div role="button" tabindex="0" [attr.aria-label]="pageData?.copy$$ada_open_chat_window?.WCAG_TEXT" id="chatBotIcon" class="cova_chat_bot_animation sc-link" (click)="open()" (keyup)="openWithEnterKey($event)"></div>
      </div>
      <div *ngIf="isIEorEdge === true || isChatBotAnimationEnabled === false">
        <div role="button" tabindex="0" [attr.aria-label]="pageData?.copy$$ada_open_chat_window?.WCAG_TEXT" id="chatBotIcon" class="cova_chat_bot_no_animation sc-link" (click)="open()" (keyup)="openWithEnterKey($event)"></div>
      </div>
     </div>
     <div *ngIf="isChatBotEnabled === false">
      <button dd-button="cova-chat" class="sc-link" (click)="open()"> Get Help</button>
     </div>

  </div>
  <div class="scroll_to_top" tabindex="0" role="button" #scrollToTop (click)="topFunction()" [attr.aria-label]="pageData?.copy$$ada_scroll_to_top?.WCAG_TEXT"><span class="scroll_to_top_icon_modified"></span></div>
</div>
